import React from 'react';
import { Helmet } from 'react-helmet';
import utils from '../utils'; // assuming utils.siteName exists
import { MdEmail } from 'react-icons/md';
import { BsTelephoneFill } from 'react-icons/bs';
import { IoLocationSharp } from 'react-icons/io5';
import { FaPaperPlane } from 'react-icons/fa';
import toast from 'react-hot-toast';

function ContactPage() {
    const url = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <div>
            <Helmet>
                <title>Contact Us - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>

            <header className="hero-bg text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-6xl font-black">Contact Us</h1>
                    <p className="mt-4 text-lg text-gray-300">We're here to help. Contact us with any questions or feedback.</p>
                    <div className="mt-6 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                </div>
            </header>

            <main className="py-16">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="grid md:grid-cols-2 gap-12 items-start">
                        {/* Contact Info */}
                        <div>
                            <h2 className="text-3xl font-bold text-primary mb-6">Get in Touch</h2>
                            <p className="mb-8 text-gray-600 dark:text-gray-300">
                                Have a question about an order, a product, or our services? Our team is ready to answer all your questions.
                            </p>
                            <div className="space-y-6">
                                <div className="flex items-start">
                                    <span className="text-primary text-3xl mr-4 flex-shrink-0">
                                        <MdEmail />
                                    </span>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100">Email</h3>
                                        <p className="text-gray-600 dark:text-gray-400">
                                            Our support team will get back to you within 24 hours.
                                        </p>
                                        <a
                                            className="text-secondary hover:text-primary dark:hover:text-orange-300 break-words"
                                            href="mailto:hello@koova.co.ke"
                                        >
                                            hello@koova.co.ke
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <span className="text-primary text-3xl mr-4 flex-shrink-0">
                                        <BsTelephoneFill />
                                    </span>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100">Phone</h3>
                                        <p className="text-gray-600 dark:text-gray-400">Mon-Fri from 9am to 5pm.</p>
                                        <a
                                            className="text-secondary hover:text-primary dark:hover:text-orange-300"
                                            href="tel:+254709677111"
                                        >
                                            +254 796 469 611
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <span className="text-primary text-3xl mr-4 flex-shrink-0">
                                        <IoLocationSharp />
                                    </span>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100">Our Office</h3>
                                        <p className="text-gray-600 dark:text-gray-400">
                                            Zenna Exhibition along Biashara Street, Nairobi, Kenya.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="bg-white dark:bg-slate-900 p-8 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg">
                            <h2 className="text-3xl font-bold text-primary mb-6">Send a Message</h2>
                            <form
                                className="space-y-6"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    // TODO: Add your form submission logic
                                    toast.error("Feature comming soon")
                                }}
                            >
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" htmlFor="name">
                                        Full Name:
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            autoComplete="name"
                                            className="input input-bordered w-full"
                                            id="name"
                                            name="name"
                                            type="text"
                                            required
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" htmlFor="email">
                                        Email Address: *
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            autoComplete="email"
                                            className="input input-bordered w-full"
                                            id="email"
                                            name="email"
                                            type="email"
                                            required
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" htmlFor="subject">
                                        Subject: *
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            autoComplete="off"
                                            className="input input-bordered w-full"
                                            id="subject"
                                            name="subject"
                                            type="text"
                                            required
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" htmlFor="message">
                                        Message: *
                                    </label>
                                    <div className="mt-1">
                                        <textarea
                                            className="textarea textarea-bordered w-full"
                                            id="message"
                                            name="message"
                                            rows="4"
                                            required
                                        ></textarea>
                                    </div>
                                </div>

                                <div>
                                    <button
                                        className="btn btn-primary w-full gap-2"
                                        type="submit"
                                    >
                                        <FaPaperPlane /> Send Message
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ContactPage;